/* Heavenly Crafted — approved Preview 6 cinematic scroll behaviour
   TIMING RULE (locked):
     first pixel enters bottom of viewport = 0%
     section top reaches top of viewport   = 100%
     progress = clamp((viewportHeight - sectionTop) / viewportHeight, 0, 1)
   Never divided by the tall section height. All media muted. */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* progress spans the approach PLUS the pinned run, minus any final hold,
     so the sequence plays at a watchable speed and every pixel of scroll
     still advances it. Nothing is ever pinned and static. */
  function prog(el, holdVh){
    var vh = window.innerHeight, t = el.getBoundingClientRect().top;
    var hold = (holdVh || 0) * vh / 100;
    var anim = Math.max(vh, (el.offsetHeight || vh) - hold);
    return Math.min(1, Math.max(0, (vh - t) / anim));
  }
  function seek(v,p){
    if(!v || !v.duration || isNaN(v.duration)) return;
    var t = Math.min(v.duration - 0.03, Math.max(0, p * v.duration));
    if(Math.abs(v.currentTime - t) > 0.012){ try{ v.currentTime = t; }catch(e){} }
  }

  /* every cinematic video is muted and inert until needed */
  var vids = [].slice.call(document.querySelectorAll('video[data-hc-scrub]'));
  vids.forEach(function(v){
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted','');
    v.playsInline = true; v.setAttribute('playsinline','');
    v.removeAttribute('autoplay'); v.pause();
  });

  /* lazy-attach sources only when the module approaches the viewport */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var v = e.target;
        if(v.dataset.src && !v.src){ v.src = v.dataset.src; v.load(); }
        io.unobserve(v);
      });
    }, {rootMargin:'400% 0px'});
    vids.forEach(function(v){ io.observe(v); });
  } else {
    vids.forEach(function(v){ if(v.dataset.src && !v.src){ v.src = v.dataset.src; v.load(); } });
  }

  var cork = document.getElementById('hcCineCork');
  var lap  = document.getElementById('hcCineLap');
  var lapLoaded = false;

  function tick(){
    if(reduce) return;

    if(cork){
      var p = prog(cork, 0);
      seek(document.getElementById('hcCorkVid'), p);
      var vg = cork.querySelector('.p6-cine-vig');
      if(vg) vg.style.background = 'radial-gradient(circle at 50% 48%, transparent '+(16+p*72).toFixed(0)+'%, rgba(1,2,6,.92) 100%)';
      var fl = cork.querySelector('.p6-cine-flare');
      if(fl){
        var flare = Math.max(0, 1 - Math.abs(p - 0.16) / 0.16);
        fl.style.opacity = (flare*0.9).toFixed(3);
        fl.style.transform = 'translate(-50%,-50%) scale('+(0.5+p*1.6).toFixed(2)+')';
      }
      var bar = cork.querySelector('.p6-cine-prog i'); if(bar) bar.style.width = (p*100).toFixed(1)+'%';
      var sc = cork.querySelector('.p6-cine-scan');   if(sc)  sc.style.top   = (p*100).toFixed(1)+'%';
      var cc = cork.querySelector('.p6-cine-copy');
      if(cc){ var o = Math.min(1, Math.max(0,(p-0.42)/0.28)); cc.style.opacity=o; cc.style.transform='translateY('+((1-o)*20).toFixed(1)+'px)'; }
      var ct = cork.querySelector('.p6-cine-cta'); if(ct) ct.classList.toggle('show', p>0.80);
    }

    if(lap){
      var q = prog(lap, 30);
      seek(document.getElementById('hcLapVid'), q);
      var lv = lap.querySelector('.p6-cine-vig');
      if(lv) lv.style.background = 'radial-gradient(circle at 50% 47%, transparent '+(48-q*30).toFixed(0)+'%, rgba(1,2,6,'+(0.5+q*0.4).toFixed(2)+') 100%)';
      var lb = lap.querySelector('.p6-cine-prog i'); if(lb) lb.style.width = (q*100).toFixed(1)+'%';
      var ls = lap.querySelector('.p6-cine-scan');   if(ls) ls.style.top   = (q*100).toFixed(1)+'%';
      var lc = lap.querySelector('.p6-cine-copy');
      if(lc){ var lo = Math.max(0, 1 - Math.max(0,(q-0.30)/0.30)); lc.style.opacity=lo; lc.style.transform='translateY('+(-(1-lo)*24).toFixed(1)+'px)'; }
      /* screen fully open at 100% and stays open through the hold — never a blank frame */
      var scr = document.getElementById('hcLapScreen');
      if(scr){
        var s = Math.min(1, Math.max(0,(q-0.55)/0.45));
        var w = 22 + s*64;
        scr.style.width = w+'vw'; scr.style.height = (w*9/16)+'vw'; scr.style.opacity = s.toFixed(3);
      }
      var fr = document.getElementById('hcLapFrame');
      if(fr){
        if(q > 0.62 && !lapLoaded){ lapLoaded = true; fr.src = fr.dataset.src; }
        if(q < 0.30 && lapLoaded){ lapLoaded = false; fr.removeAttribute('src'); }
      }
      var lct = lap.querySelector('.p6-cine-cta'); if(lct) lct.classList.toggle('show', q>0.97);
    }

    /* split-module product videos use the identical rule */
    document.querySelectorAll('video[data-hc-scrub="split"]').forEach(function(v){ seek(v, prog(v, 0)); });
  }

  var ticking=false;
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ tick(); ticking=false; }); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', tick);
  vids.forEach(function(v){ v.addEventListener('loadedmetadata', tick); });
  tick();

  /* reduced motion: show the channel player immediately, no scrubbing */
  if(reduce){
    var fr2 = document.getElementById('hcLapFrame');
    if(fr2 && fr2.dataset.src) fr2.src = fr2.dataset.src;
    var scr2 = document.getElementById('hcLapScreen'); if(scr2) scr2.style.opacity = 1;
  }

  /* flashlight — source-theme interaction, pointer devices only */
  (function(){
    if(reduce) return;
    var hero = document.querySelector('.hero'); if(!hero) return;
    if(window.matchMedia && window.matchMedia('(hover:none)').matches) return;
    hero.addEventListener('mousemove', function(e){
      var r = hero.getBoundingClientRect();
      hero.classList.add('p6-flash-on');
      hero.style.setProperty('--fx', (((e.clientX-r.left)/r.width)*100).toFixed(1)+'%');
      hero.style.setProperty('--fy', (((e.clientY-r.top)/r.height)*100).toFixed(1)+'%');
    });
    hero.addEventListener('mouseleave', function(){ hero.classList.remove('p6-flash-on'); });
  })();
})();
